import { FC } from 'react';
import clsx from 'clsx';

import { IconButton } from '@components/shared/buttons/icon-button/IconButton';

import classes from './Chip.module.scss';

interface IChipProps {
  isDisabled?: boolean;
  label: string;
  onDelete: () => void;
}

const Chip: FC<IChipProps> = ({ label, onDelete, isDisabled }) => (
  <div className={classes.chip}>
    <span>{label}</span>
    <IconButton
      ariaLabel="Видалити атрибут"
      icon="cross"
      className={clsx(classes.chipIcon, { [classes.inactive]: isDisabled })}
      iconSize={10}
      onClick={onDelete}
    />
  </div>
);

export default Chip;
